import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { useChatStore } from '@/stores/chatStore'
import { useChatRealtime } from '@/realtime/useChatRealtime'

const CHAT_ROLES = new Set(['teacher', 'student', 'admin'])

/**
 * Глобальная синхронизация чата для sidebar-индикатора и realtime вне ChatPage.
 */
export function useChatGlobalSync(): void {
  const user = useAuthStore((s) => s.user)
  const fetchRooms = useChatStore((s) => s.fetchRooms)

  const canSync =
    user?.roles?.some((role) => CHAT_ROLES.has(role.slug)) ?? false

  useEffect(() => {
    if (!canSync) return
    void fetchRooms()
  }, [canSync, fetchRooms])

  useChatRealtime()
}
